import React from 'react'
import * as Errors from '@morningtrain/react-errors'

export default function Widget ({ children }) {
  return (
    <Errors.Boundary>
      {children}
    </Errors.Boundary>
  )
}
